
import {get} from 'lodash-es'
import {timeIsValid, timeFilter} from 'helpers/date'
import {spaceship} from 'helpers/sort'
import BaseModel from 'models/BaseModel'

export default class BasePerson extends BaseModel {

  // アクセサ: 社員コードを取得
  get code() {
    return this.person_code
  }

  // アクセサ: 検索用キー値を取得
  get key() {
    return this.constructor.key(this)
  }

  // アクセサ: 表示用文字列
  get label() {
    return this.name
  }

  // アクセサ: 表示用文字列(短縮形)
  get short_label() {
    return this.short_name
  }

  // アクセサ: 勤務時刻の表示用文字列
  static makeTimeLabel(begin_time, end_time) {
    return timeIsValid(begin_time, end_time)
      ? timeFilter(begin_time) + '〜' + timeFilter(end_time)
      : null
  }

  // アクセサ: 変更可能か？
  get isWritable() {
    return this.writable != 0
  }

  // 配列処理: 並び順でソート
  static sort(people) {
    return Object.values(people).sort((a, b) =>
      spaceship(a.group,       b.group      ) ||
      spaceship(a.order,       b.order      ) ||
      spaceship(a.person_code, b.person_code)
    )
  }

  // 氏名から短縮名を作成する
  static makeShortName(name) {
    return get(name.match(/\s*(\S+)/u), 1, '')
  }

}
